<template>
<div class="item-view-container" v-if="!renderedMote">
	
</div>
<div class="item-view-container" v-else>
	<div class="item-view-card">
		<!-- Image container with responsive sizing -->
		<div class="item-image-container">
			<img v-if="sampleInventoryItem?.image" :src="sampleInventoryItem.image" class="item-image" />
		</div>

		<!-- Details container with flex-wrap -->
		<div class="item-details">
			<div class="item-title">
				<span style="font-weight:bold;">{{ renderedMote.moteTitle() }}</span>
			</div>
			<div class="fields-grid">
				<template v-for="field in renderedMote.getMoteFields()" :key="field.id">
					<div v-if="field.fieldtype !== 'attachment' && renderedMote.payload[field.field]" class="field-datarow">
						<span class="field-taghead">{{ field.label }}</span>
						<template v-if="field.fieldtype == 'relationship'">
							<a href="#" v-for="relatedMote in renderedMote.payload[field.field]" :key="relatedMote.rel_id">
								<span class="field-dataspan">#{{ relatedMote.mote_id }}</span>
							</a>
						</template>
						<template v-else>
							<span class="field-dataspan">{{ renderedMote.payload[field.field] }}</span>
						</template>
					</div>
				</template>
			</div>
		</div>

		<!-- Action buttons -->
		<div class="action-buttons">
			<DxButton icon="info" text="View" class="action-button" />
			<DxButton icon="edit" text="Edit" class="action-button" />
			<DxButton icon="optionsgear" text="Actions" class="action-button" />
		</div>
	</div>
</div>
</template>

<style scoped>
.item-view-container {
	margin: 15px;
	overflow: hidden;
}

.item-view-card {
	background: #eee;
	border: 1px solid var(--dx-color-primary);
	padding: 15px;
	border-radius: 5px;
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
}

.item-image-container {
	flex: 0 0 200px;
	max-width: 300px;
	min-width: 150px;
}

.item-image {
	width: 100%;
	height: auto;
	object-fit: contain;
}

.item-details {
	flex: 1 1 400px;
	min-width: 300px;
}

.item-title {
	margin-bottom: 1em;
}

.fields-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 1em;
}

.action-buttons {
	display: flex;
	flex-direction: column;
	gap: 10px;
	flex: 0 0 auto;
}

.action-button {
	width: 120px;
}

@media (max-width: 768px) {
	.item-view-card {
		flex-direction: column;
	}

	.item-image-container {
		max-width: 100%;
	}

	.action-buttons {
		flex-direction: row;
		justify-content: center;
		flex-wrap: wrap;
	}
}
</style>

<script setup>
import DxButton from 'devextreme-vue/button';
import { defineProps, computed } from 'vue';

const props = defineProps([
	'preview',
	'settings',
	'context'
]);

const renderedMote = computed(() => {
	return props.context && props.context.hasValidContext() ? props.context.context : null;
});

const sampleInventoryItem = {
	id: 1,
	name: 'Forklift Type E6a',
	type: 'inventory_item',
	vendorCost: 17555.00,
	msrp: 20000.00,
	responsible: 'Sample Employee',
	countSold: 135,
	lastSold: '2024/09/18 10:35AM',
	lastPO: '#1742',
	warehouseCount: 5,
	queueMode: 'LIFO',
	image: require('/src/assets/blur_forklift.png'),
};



</script>
